import { useEffect } from 'react';

export const useVisibilityChange = (callback: (focus: boolean) => void, deps) => {
  useEffect(() => {
    const handleVisibilityChange = () => {
      callback(!document.hidden);
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, deps);
};
